module.exports = __webpack_public_path__ + "img/kpop-demon-hunter.c7eed7da.jpg";